/**
 * @desc 监听页面旋转
 * @author liushuai
 */
import { useEffect, useState } from 'react';
import { $window } from '@umu/umu-dom';

export const useOrientation = () => {
    const [orientation, setOrientation] = useState(Date.now());
    const onOrientationChange = () => {
        setOrientation(Date.now());
    };
    useEffect(() => {
        $window.addEventListener('orientationchange', onOrientationChange);
        return () => {
            $window.removeEventListener('orientationchange', onOrientationChange);
        };
    }, []);
    return [orientation];
};
